export default __webpack_public_path__ + "static/media/MSC.8b532b4b.png";